// extracted by mini-css-extract-plugin
export default {"chip-icon":"ChipIcon_chip-icon__Yqclm","chip-icon-format-default":"ChipIcon_chip-icon-format-default__qv9rD","chip-icon-format-compact":"ChipIcon_chip-icon-format-compact__AcKH+"};